module.exports = __webpack_public_path__ + "img/logo_radalab.0942f23b.jpg";